import React from 'react'
import { useParams } from 'react-router-dom'

import ProductAttributeForm from '@components/catalog/productAttribute/ProductAttributeForm'

import { useGoBackOrRedirect } from '@@partner:helpers/hooks/location'

import { ROUTE_PRODUCT_ATTRIBUTES } from '@@partner:config/routes'


export default function SingleProductAttributePage () {
  
  const { attributeId, brandSlug } = useParams<any>()
  const redirectToCatalog = useGoBackOrRedirect(ROUTE_PRODUCT_ATTRIBUTES, {
    brandSlug
  })
  
  return (
    <div className="CatalogCategoryPage">
      <h1 className="u-heading">
        {attributeId ? 'Редактирование' : 'Добавление'}
      </h1>
      <ProductAttributeForm attributeId={attributeId} onSaved={redirectToCatalog} />
    </div>
  )
}